module.exports = " <img src=" + require("../../static/img/aihaozhe_shouhoutongzhi.png") + " v-show=isFan class=content_wrap :style=\"{height: imageHeight + 'px'}\" _v-c7f96cf0=\"\"> <img src=" + require("../../static/img/shouhoutongzhi_wenshenshi.png") + " v-show=!isFan class=content_wrap2 :style=\"{height: imageHeight2 + 'px'}\" _v-c7f96cf0=\"\"> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-c7f96cf0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service.vue
// module id = 425
// module chunks = 31